<template>
  <div class="hotel-order">
    <div class="order-text-box">
      <div class="order-text-box-content">
        <div class="text-box-left">
          <img :src="orderDetail.imageUrl" alt="">
          <div>
            <p class="title">{{orderDetail.hotelNameCn}}</p>
            <p>{{orderDetail.keyName}}</p>
            <p>订单号：{{orderDetail.orderNo}}</p>
            <p>确认号：{{orderDetail.confirmNo}}</p>
          </div>
        </div>
        <div class="text-box-right">
          <p>
            订单总金额：
            <span>
              <span>¥</span>
              {{orderDetail.orderAmount}}
            </span>
          </p>
          <p>
            已付款：
            <span>
              <span>¥</span>
              {{orderDetail.paidAmount}}
            </span>
          </p>
          <p>
            待付款：
            <span>
              <span>¥</span>
              {{orderDetail.noPaidAmount}}
            </span>
          </p>
          <p>下单时间：{{orderDetail.createTime}}</p>
        </div>
        <div class="text-box-btn flex-center">
          <span>{{orderDetail.orderStatusName}}</span>
        </div>
      </div>
    </div>
    <div class="order-list clear" v-if="$route.query.type == 'cancel'">
      <div class="order-list-head font-15">订单信息</div>
      <div class="order-list-box">
        <div class="order-list-info">
          <span>取消原因：</span>
          <div class="list-info-cause">
            <el-input type="textarea" :rows="4" readonly v-model="orderDetail.cancelRemark"></el-input>
          </div>
        </div>
        <div class="order-list-info">
          <span>取消结果：</span>
          <span>{{orderDetail.cancelStatusName}}</span>
        </div>
        <div class="order-list-info">
          <span>退款金额：</span>
          <span>
            <i class="font-10" style="font-style:normal">¥</i>
            {{orderDetail.cancelAmount||'0'}}
          </span>
        </div>
      </div>
      <div class="order-list-head font-15">取消订单信息</div>
      <div class="order-list-info">
        <div class="order-user-info">
          <table class="table" width="99%">
            <tr>
              <th>入住时间</th>
              <th>离店时间</th>
              <th>入住天数</th>
              <th>房间数</th>
            </tr>
            <tr>
              <td>
                <span>{{orderDetail.checkInDate}}</span>
              </td>
              <td>
                <span>{{orderDetail.checkOutDate}}</span>
              </td>
              <td>
                <span>{{orderDetail.stayNights}}</span>
              </td>
              <td>
                <span>{{orderDetail.roomNum}}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!-- <div class="order-list-head font-15">预定信息</div> -->
      <!-- <el-col class="order-list-box">
                <div class="order-list-info">
                    <span>房源信息：</span><span>{{orderDetail.hotelNameCn}}</span>
                </div>
                <div class="order-list-info">
                    <span>入驻日期：</span>
                    <div class="flex-center-end">
                         <el-date-picker
                            v-model="enterDay"
                            type="daterange"
                            readonly
                            range-separator="到"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                            </el-date-picker>
                            <div class="order-day-num">
                                <i>共</i>
                                  <el-input type="text" readonly v-model="orderDetail.stayNights" class="order-list-info-input"></el-input>
                                <i>晚</i>
                            </div>
                    </div>
                </div>
                <div class="order-list-info">
                    <span>房间数量：</span>
                    <div>
                        <el-input type="text" readonly v-model="orderDetail.roomNum" class="order-list-info-input"></el-input>
                        <i class="room-warn"><sub>*</sub>每间房最多住2人，一次最多预定5间</i>
                    </div>
                </div>
                <div class="order-list-info">
                    <span>到店最晚时间：</span><div>
                        <el-time-picker
                        v-model="arriveTime"
                        placeholder="到店最晚时间">
                        </el-time-picker>
                    </div>
                </div>
                <div class="order-list-info">
                    <span>房费情况：</span>
                    <div class="roomRate" v-for="(item,index) in home" :key="index">
                        <div class="roomRateItem">
                            <p class="room-title">{{item.date}}</p>
                            <div class="room-rate-money">
                                <p><i>¥</i>{{item.supplierPrice}}</p>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
      </el-col>-->
    </div>
    <div class="order-list clear">
      <div class="order-list-head font-15">入住人信息</div>
      <div class="order-user-info">
        <table class="table" width="99%">
          <tr>
            <th>姓</th>
            <th>名</th>
            <th>性别</th>
            <th>证件类型</th>
            <th>证件号</th>
            <th>国籍</th>
            <!-- <th>操作</th> -->
          </tr>
          <tr v-for="(item,index) in orderPersonList" :key="index">
            <td>
              <el-input v-model="item.lastName" readonly></el-input>
            </td>
            <td>
              <el-input v-model="item.firstName" readonly></el-input>
            </td>
            <td>
              <el-input v-model="item.genderName" readonly></el-input>
            </td>
            <td>
              <el-input v-model="item.certificatesTypeName" readonly></el-input>
            </td>
            <td>
              <el-input v-model="item.certificatesNumber" readonly></el-input>
            </td>
            <td>
              <el-input v-model="item.nationality" readonly></el-input>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="order-list clear">
      <div class="order-list-head font-15">给酒店留言</div>
      <div class="text-area">
        <el-input type="textarea" :rows="8" readonly v-model="orderDetail.hotelRemark"></el-input>
      </div>
    </div>
    <div class="order-list clear">
      <div class="order-list-head font-15">联系人信息</div>
      <div class="flex-center-end form-box">
        <el-form label-width="100px" :model="orderDetail" class="form-user" ref="userForm">
          <p class="form-title">联系人一</p>
          <el-form-item label="姓名:" prop="buyerLinkman">
            <el-input v-model="orderDetail.buyerLinkman" readonly></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="buyerPhone">
            <el-input v-model="orderDetail.buyerPhone" readonly></el-input>
          </el-form-item>
          <el-form-item label="传真号码:" prop="buyerFax">
            <el-input v-model="orderDetail.buyerFax" readonly></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱:" prop="buyerMail">
            <el-input v-model="orderDetail.buyerMail" readonly></el-input>
          </el-form-item>
        </el-form>
        <el-form label-width="100px" :model="orderDetail" class="form-user">
          <p class="form-title">联系人二</p>
          <el-form-item label="姓名:">
            <el-input v-model="orderDetail.buyerSecondLinkman" readonly></el-input>
          </el-form-item>
          <el-form-item label="联系电话:">
            <el-input v-model="orderDetail.buyerSecondPhone" readonly></el-input>
          </el-form-item>
          <el-form-item label="传真号码:">
            <el-input v-model="orderDetail.buyerSecondFax" readonly></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱:">
            <el-input v-model="orderDetail.buyerSecondMail" readonly></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="order-list clear" v-if="orderDetail.description">
      <div class="order-list-head font-15">礼包信息</div>
      <div class="text-area">
        <el-input type="textarea" :rows="8" readonly v-model="orderDetail.description"></el-input>
      </div>
    </div>
    <div class="order-list clear">
      <div class="order-list-head font-15">下单须知</div>
      <div class="order-user-info">
        <p class="notice-text">预定须知:</p>
        <table class="table" width="90%">
          <tr>
            <th>开始时间</th>
            <th>结束时间</th>
            <th>预定数量</th>
            <th>入住天数</th>
            <th>提前预定时间</th>
            <th>有效星期</th>
            <th>销售时间</th>
            <th>预定说明</th>
          </tr>
          <tr>
            <td>
              <span>{{orderDetail.startDate}}</span>
            </td>
            <td>
              <span>{{orderDetail.endDate}}</span>
            </td>
            <td>
              <p>最少: {{orderDetail.minAmount}}</p>
              <p>最多: {{orderDetail.maxAmount}}</p>
            </td>
            <td>
              <p>最少: {{orderDetail.minDays}}</p>
              <p>最多: {{orderDetail.maxDays}}</p>
            </td>
            <td>
              <p>最早: {{orderDetail.minAdvHours}}</p>
              <p>最迟: {{orderDetail.maxAdvHours==-1?'无限制':''}}</p>
            </td>
            <td v-if="orderDetail.weekSet">
              <span v-for="(item,index) in orderDetail.weekSet.split(',')" :key="index">
                星期{{item==1?'一':
                item==2?'二':item==3?'三':item==4?'四':item==5?'五':item==6?'六':'日'}}
              </span>
            </td>
            <td>
              <p>开始时间: {{orderDetail.startTime}}</p>
              <p>结束时间: {{orderDetail.endTime}}</p>
            </td>
            <td>
              <span>{{orderDetail.bookingNotices}}</span>
            </td>
          </tr>
        </table>
        <p class="notice-text">取消条款：</p>
        <table class="table" width="90%">
          <tr>
            <th>取消条款规则</th>
            <th>入住前n小时</th>
            <th>取消客人罚金</th>
          </tr>
          <tr>
            <td>
              <span>{{orderDetail.refundRuleType == 1?'不可退':'限时取消'}}</span>
            </td>
            <td>
              <span>{{orderDetail.refundRuleHours || 30}}(小时)</span>
            </td>
            <td>
              <span>{{orderDetail.deductType == 1?'扣全额':orderDetail.deductType == 0?'扣首晚房费':''}}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="flex-center" style="margin:30px 0 50px 0">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import { queryHotelOrderDetails } from "@/lib/data-service/hotel";
import { STATUS } from "@/lib/deprecated/utils/status";
const SUCCESS_CODE = STATUS.success;
export default {
  name: "hotelOrder",
  data() {
    return {
      formData: {},
      home: [],
      enterDay: [],
      orderDetail: {},
      orderPersonList: []
    };
  },
  activated() {
    this.getList();
    console.log(this.$route.query.type);
  },
  watch: {},
  methods: {
    getList() {
      let data = {
        orderNo: this.$route.query.orderNo
      };
      queryHotelOrderDetails(data).then(res => {
        if (res.code === SUCCESS_CODE) {
          console.log(res);
          this.orderDetail = res.orderDetailsResult;
          this.orderPersonList = res.orderPersonList;
          this.enterDay = [
            res.orderDetailsResult.checkInDate,
            res.orderDetailsResult.checkOutDate
          ];
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.hotel-order {
  // display: flex;
  color: #4b4b4b;
  .order-list {
    margin: 10px 0;
    border: solid 1px #b2b2b2;
    .order-list-head {
      background: #ecf6ff;
      padding: 10px 20px;
      position: relative;
      &::after {
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        content: "";
        height: 100%;
        width: 5px;
        background: #5bb4ff;
      }
    }
    .text-area {
      padding: 10px;
    }
  }
  .order-list-box {
    padding: 30px;
    .order-list-info {
      font-size: 16px;
      padding: 10px;
      display: flex;
      align-items: center;
      .order-list-info-input {
        width: 100px;
      }
      .list-info-cause {
        width: 80%;
      }
      .order-list-info-text {
        width: 80%;
        margin: auto;
      }
      .room-warn {
        font-size: 10px;
        color: #b2b2b2;
        font-style: normal;
      }
      span:nth-child(1) {
        display: inline-block;
        text-align: end;
        width: 120px;
      }
      span:nth-child(2) {
        display: inline-block;
        color: #237dc8;
      }
      .order-day-num {
        margin-left: 20px;
        i {
          font-size: 15px;
          padding: 0 5px;
          font-style: normal;
        }
      }
    }
  }
  .order-add-user {
    display: inline-block;
    padding-left: 5px;
    font-size: 15px;
  }
  .form-box {
    width: 80%;
    margin: auto;
    .form-user {
      width: 400px;
      margin: 23px 0 0 0;
      font-size: 14px;
      .form-title {
        padding-left: 100px;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: normal;
        letter-spacing: 1px;
        color: #4b4b4b;
        font-stretch: normal;
        font-family: MyriadPro-Regular;
      }
    }
  }
  .order-user-info {
    .notice-text {
      width: 90%;
      margin: auto;
      font-size: 14px;
      color: #8c8c8c;
      padding-top: 10px;
    }
    .table {
      margin: auto;
      margin-top: 20px;
      margin-bottom: 20px;
      border-collapse: collapse;
      th {
        font-size: 13px;
      }
      td {
        text-align: center;
        font-size: 12px;
      }
    }
    table td,
    table th {
      border: 1px solid #cad9ea;
      color: #666;
      height: 30px;
    }
  }
  .colse-account {
    width: 25%;
    margin: 10px 20px;
    .colse-account-content {
      min-height: 100px;
      border: solid 1px #b2b2b2;
    }
    .colse-accound-head {
      background: #237dc8;
      color: white;
      font-size: 16px;
      padding: 12px 20px;
    }
    .colse-accound-img {
      height: 165px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .colse-accound-box {
      padding: 17px 25px;
      font-size: 10px;
      color: #7b7b7b;
      p {
        padding: 3px 0;
      }
      .title {
        color: #237dc8;
        font-size: 18px;
        font-weight: bold;
      }
      .title-english {
        color: #237dc8;
        font-size: 12px;
      }
      .hose {
        color: #237dc8;
        font-size: 16px;
        padding: 18px 0 10px 0;
      }
    }
    .colse-accound-money {
      background: #fafafa;
      padding: 10px 0;
      p:nth-child(1) {
        font-size: 18px;
        color: #666;
        font-weight: bold;
        text-align: end;
        padding: 10px;
        span {
          font-size: 16px;
          font-weight: 400;
          color: #ff6600;
        }
        border-bottom: 1px dashed #b2b2b2;
      }
      p:nth-child(2) {
        font-size: 14px;
        color: #666;
        padding: 10px;
        text-align: end;
      }
      .btn {
        height: 37px;
        background: #ff6600;
        color: white;
        font-size: 17px;
        width: 159px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .roomRate {
    border: 1px solid #ccc;
    color: #8c8c8c;
    font-size: 12px;
    text-align: center;
    // &:nth-child(2n){
    //     border-right: 0;
    // }
    .roomRateItem {
      .room-title {
        background: #ecf6ff;
        padding: 3px 10px;
      }
      .room-rate-money {
        padding: 8px 15px;
        p:nth-child(1) {
          font-size: 16px;
          color: #ff6600;
          padding-bottom: 1px;
          i {
            font-style: normal;
            padding-right: 5px;
          }
        }
      }
    }
  }
  /deep/.el-input {
    height: 30px;
    input {
      height: 30px;
      border-radius: 0;
    }
  }
  .el-input-number {
    line-height: 28px;
  }

  .el-input__inner {
    border-radius: 0;
    padding: 0;
    height: 30px;
    line-height: 30px;
  }
  /deep/.el-date-editor .el-range__icon {
    line-height: 25px;
    margin-left: 0;
  }
  /deep/.el-range-separator {
    line-height: 28px;
  }
  /deep/.el-select__caret {
    line-height: 0;
  }
  /deep/.el-icon-time {
    line-height: 30px;
  }
  /deep/.el-input__suffix .el-input__icon {
    line-height: 30px;
  }
  .order-text-box {
    background: #fff4ee;
    border: 1px solid #ffc096;
    margin-bottom: 10px;
    padding: 10px 20px;
    font-size: 14px;
    color: #666;
    .title {
      color: #4c93d0;
      font-size: 18px;
    }

    .order-text-box-content {
      display: flex;
      justify-content: space-between;
    }
    .text-box-left {
      display: flex;
      margin-right: 100px;
      p {
        padding: 5px 0;
        padding-left: 30px;
      }
      img {
        width: 200px;
        height: 120px;
        // border: 1px solid black;
      }
    }
    .text-box-right {
      p {
        padding: 5px 0;
        span {
          color: #ff7e2e;
          padding-right: 2px;
        }
      }
    }
    .text-box-btn {
      color: #ff7e2e;
      font-size: 18px;
    }
  }
}
</style>


